import type { UseMutationResult } from "@tanstack/react-query";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface InviteDialogProps {
  readonly formError: string | null;
  readonly inviteEmail: string;
  readonly inviteMutation: UseMutationResult<unknown, Error, string, unknown>;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onSetInviteEmail: (value: string) => void;
}

export function InviteDialog({
  formError,
  inviteEmail,
  inviteMutation,
  isOpen,
  onClose,
  onSetInviteEmail,
}: InviteDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite member</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="invite-email">Email address</Label>
            <Input
              id="invite-email"
              type="email"
              autoFocus
              value={inviteEmail}
              onChange={(event) => onSetInviteEmail(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter" && inviteEmail) inviteMutation.mutate(inviteEmail);
              }}
              placeholder="friend@example.com"
            />
          </div>
          {formError && <p className="text-sm text-destructive">{formError}</p>}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => inviteMutation.mutate(inviteEmail)}
            disabled={!inviteEmail || inviteMutation.isPending}
          >
            {inviteMutation.isPending ? "Sending..." : "Send invite"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
